<template>
  <app-modal id="modal-forgot-password" hide-footer>
    <h4 class="text-center">
      {{ t("Forgot Password") }}
    </h4>

    <form-forgot-password />

    <span class="bg-sticker star-nude-large">
      <img v-lazy="starNudeDarkSticker" :alt="`sticker star nude`" width="20" height="20" />
    </span>

    <span class="bg-sticker star-mint-large">
      <img v-lazy="starMintDarkSticker" :alt="`sticker star mint`" width="18" height="18" />
    </span>
  </app-modal>
</template>

<script setup lang="ts">
import AppModal from "@/components/v2/modals/modal";
import FormForgotPassword from "@/components/v2/form-forgot-password/index.vue";
import { useI18n } from "vue-i18n";
import starNudeDarkSticker from "@/assets/v2/images/stickers/star-nude-dark.svg";
import starMintDarkSticker from "@/assets/v2/images/stickers/star-mint-dark.svg";

defineOptions({
  name: "modal-forgot-password",
});
const { t } = useI18n();
</script>

<style lang="scss">
@import "./index.scss";
</style>
